
// src/components/UnverifiedBanner.jsx
import React, { useEffect, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { auth } from "../../firebase";
import { onAuthStateChanged, sendEmailVerification } from "firebase/auth";

export default function UnverifiedBanner({ communityId }) {
  const [user, setUser] = useState(auth.currentUser || null);
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (u) {
        // Ensure we have the latest emailVerified flag
        try {
          await u.reload();
        } catch {}
      }
      setUser(u);
    });
    return unsub;
  }, []);

  if (!user || user.emailVerified) return null;

  const handleResend = async () => {
    if (!user) return;
    setLoading(true);
    setMsg("");
    try {
      await sendEmailVerification(user, {
        url: `${window.location.origin}/verify-success?community=${communityId || ""}`,
        handleCodeInApp: false,
      });
      setMsg("Verification email resent. Check your inbox and spam folder.");
    } catch (e) {
      console.error("Resend failed:", e);
      setMsg(e?.message || "Could not resend verification email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Alert variant="warning" className="d-flex align-items-center justify-content-between">
      <div>
        <strong>Email not verified.</strong> Please verify your email to unlock all features.
      </div>
      <div>
        <Button onClick={handleResend} disabled={loading} size="sm">
          {loading ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" /> Resending…
            </>
          ) : (
            "Resend verification"
          )}
        </Button>
      </div>
      {msg && <div className="w-100 text-muted small mt-2">{msg}</div>}
    </Alert>
  );
}
